import { connect } from 'react-redux';

import Treatment from './Treatment';
import {
  getTreatment,
  clearTreatment,
} from '../../../store/admin/treatment/actions';

const mapStateToProps = (state) => ({
  loading: state?.admin?.treatment?.loading,
  data: state?.admin?.treatment?.data,
});

const mapDispatchToProps = (dispatch) => ({
  getTreatment: (timePeriod) => dispatch(getTreatment(timePeriod)),
  clearTreatment: () => dispatch(clearTreatment()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Treatment);
